import { UnifiedNavigationApp } from 'ca-navigation/UnifiedNavigationApp';
import registerComponentType from 'ca-react-automount';

export function register(registerComponent: typeof registerComponentType) {
  registerComponent('UnifiedNavigationApp', UnifiedNavigationApp);
}
